import axiosInstance from "../config/axiosInstance";


export const authLogin = async (email, password) => {

        const { data } = await axiosInstance.post("/api/admin/login", {
          email,
          password,
        });
      
        return data;
   
}

export const adminProfile  = async (email, password) => {
    try {
        const { data } = await axiosInstance.get("/api/auth/myprofile");



        return data?.data;
      
    } catch (e) {
        console.error(e);

    }
}
export const addUser = async ({
  name,
  designation,
  countryCode,
  email,
  password,
  phoneNumber,
  businessName,
  gstNumber,
  entryType,
  industryType,
  businessCategory,
  address,
  city,
  street,
  state,
  country,
  postalCode,
  profilePic,
}) => {

  let form = new FormData();
  form.append("address", address);
  form.append("businessCategory", businessCategory);
  form.append("businessName", businessName);
  form.append("city", city);
  form.append("country", country);
  form.append("countryCode", countryCode);
  form.append("designation", designation);
  form.append("email", email);
  if (designation === "User") form?.append("gstNumber", gstNumber);
  form.append("industryType", industryType);
  form.append("name", name);
  form.append("password", password);
  form.append("phoneNumber", phoneNumber);
  form.append("postalCode", postalCode);
  form.append("state", state);
  form.append("street", street);
  form.append("entryType", entryType);
  form.append("profilePic", profilePic);

  const { data } = await axiosInstance.post(
    "/api/admin/create/createUser",
    form,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data?.data;
};

export const editUser = async ({
  id,
  name,
  designation,
  countryCode,
  email,
  password,
  phoneNumber,
  businessName,
  gstNumber,
  entryType,
  industryType,
  businessCategory,
  address,
  city,
  street,
  state,
  country,
  postalCode,
  profilePic,
  businessOverview,
}) => {
  let form = new FormData();
  form.append("address", address);
  form.append("businessCategory", businessCategory);
  form.append("businessName", businessName);
  form.append("city", city);
  form.append("country", country);
  form.append("countryCode", countryCode);
  form.append("designation", designation);
  form.append("email", email);
  if (designation === "User") form?.append("gstNumber", gstNumber);
  form.append("industryType", industryType);
  form.append("name", name);
  form.append("password", password);
  form.append("phoneNumber", phoneNumber);
  form.append("postalCode", postalCode);
  form.append("state", state);
  form.append("street", street);
  form.append("entryType", entryType);
  form.append("profilePic", profilePic);
  form.append("businessOverview", businessOverview);

  const response = await axiosInstance.put(`/api/admin/update/user/${id}`, form, {
    headers: {
      "Content-Type": "multipart/form-data",
    },

  });
  return response;
};